/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {OfferTableSettings} from './OfferTableSettings';
import {OfferSpecification} from './OfferSpecification';

export interface Offer {
  id?: number;
  header: string;
  description?: string;
  contactsFinal?: string;
  contactsIntro?: string;
  title?: string;
  textIntro?: string;
  textFinal?: string;
  updatedAt?: Date;
  createdAt?: Date;
  picture?: string;
  vatRate?: number;
  totalCost?: number;
  tableSettings?: OfferTableSettings;
  specification: OfferSpecification;
  enabled?: boolean;
  fileInput?: File;
}
